import api from '~/services/api';
import { FormattedData } from '../types';

const createAdministradora = async (
  AdministradoraData: FormattedData,
): Promise<{ message: string; success: boolean }> => {
  const { data } = await api.post(
    '/administradora-cartoes',
    AdministradoraData,
  );
  return data;
};

const updateAdministradora = async (
  cod_administradora: number,
  AdministradoraData: FormattedData,
): Promise<{ message: string; success: boolean }> => {
  const { data } = await api.put(
    `/administradora-cartoes/${cod_administradora}`,
    AdministradoraData,
  );
  return data;
};

const getBandeiras = async (
  cod_administradora: number,
): Promise<{ data: any; success: boolean }> => {
  const { data } = await api.get(
    `/administradora-cartoes-bandeiras/${cod_administradora}`,
  );
  return data;
};

export const administradoraServices = {
  createAdministradora,
  updateAdministradora,
  getBandeiras,
};
